<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <font-awesome-icon :icon="['fas', 'ban']" class="text-warning" />
                        {{ $t('simple.deactivate') }} — {{ account.name }}
                    </h5>
                    <button type="button" class="close" aria-label="Close" @click="$close(false)">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <b-alert variant="warning" show>
                        {{ $t('simple.deactivate_confirm', { account_name: account.name, integration_id: account.integration_id }) }}
                    </b-alert>
                </div>

                <div class="modal-footer">
                    <b-button variant="secondary" @click="$close(false)">{{ $t('simple.cancel') }}</b-button>
                    <b-button variant="warning" @click="$close(true)">
                        <font-awesome-icon :icon="['fas', 'ban']" /> {{ $t('simple.deactivate') }}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['account'],
}
</script>
